// extracted by mini-css-extract-plugin
export var component = "SearchComponent-module--component--2cb89";
export var fadePop = "SearchComponent-module--fade-pop--802e4";
export var growHeightIn = "SearchComponent-module--grow-height-in--b1c15";